import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../dto';
import { catchError } from 'rxjs/operators';
import { handleApiError } from '../utils';

@Injectable()
export class WsSolicitudesService {
    private endpoint = `/api/WsSolicitudes`;

    constructor(private http: HttpClient) { }

    registro(solicitud, ctx?: any): Observable<ApiResponse<number>> {
        if (solicitud.IdContacto) {
            solicitud.Empresa = null;
            solicitud.Nombres = null;
            solicitud.Apellidos = null;
            solicitud.Email = null;
            //solicitud.Celular = null;
        }

        return this.http.post<ApiResponse<number>>(`${this.endpoint}/registrar`, { solicitud }, {
            headers: {
                context: ctx || 'body'
            }
        }).pipe(
            catchError(handleApiError<number>())
        );
    }
}
